export const allTypes = {
    transfer_type: 'Tipo de Transacción',
    p2p_immediate: 'Transferencia Inmediata',
    p2p_scheduled: 'Transferencia Programada',
    p2p_periodic: 'Transferencia Periódica',
    goal_immediate: 'Depósito Inmediato Meta',
    goal_scheduled: 'Depósito Programado Meta',
    goal_periodic: 'Depósito Periódico Meta',
    goal_refund: 'Devolución Meta',
    rapipago_cashout: 'Retiro en Rapipago',
    rapipago_cashin: 'Depósito en Rapipago',
    extracash_cashout: 'Retiro en Comercio',
    qr_payment: 'Pago con QR',
    link_payment: 'Link de Pago',
    division_payment: 'Division de Gs. entre Amigos',
    cargavirtual_claro: 'Recarga Claro',
    cargavirtual_movistar: 'Recarga Movistar',
    cargavirtual_personal: 'Recarga Personal',
    cargavirtual_directv: 'Recarga DirecTv',
    cargavirtual_tuenti: 'Recarga Tuenti',
    cargavirtual_sube: 'Recarga SUBE (CV)',
    commission: 'Comisión',
    rapipago_commission: 'Comisión Rapipago',
    cargavirtual_claro_commission: 'Comisión Claro',
    cargavirtual_movistar_commission: 'Comisión Movistar',
    cargavirtual_personal_commission: 'Comisión Personal',
    cargavirtual_tuenti_commission: 'Comisión Tuenti',
    cargavirtual_directv_commission: 'Comisión Direct TV',
    cargavirtual_sube_commission: 'Comisión SUBE TV',
    nssa_sube_commission: 'Comisión SUBE (NS)',
    nssa_sube_merchant_commission: 'Comisión SUBE en Comercio',
    nssa_sube: 'Recarga SUBE (NS)',
    nssa_sube_merchant: 'Recarga SUBE en Comercio',
    gp_authorization: 'Pago con Tarjeta',
    gp_authorization_forced: 'Autorización Forzada',
    gp_withdraw: 'Retiro por ATM',
    gp_refund: 'Devolución Pago con Tarjeta',
    recharge_utility: 'Recarga de Servicio',
    adjustment_operational: 'Ajuste Operacional',
    adjustment_comercial: 'Ajuste Comercial',
    tax: 'Impuesto',
    tax_ar_iva: 'IVA', // 'IVA Credito Fiscal', // 'Ret. de IVA',
    tax_ar_iibb: 'Ingresos Brutos',
    tax_ar_ley27541: 'Imp. País Ley 27541',
    tax_ar_ig: 'Ret. Imp. Gcias RG 4622',
    cvu_immediate: 'Tcia. Inmediata CVU',
    cvu_scheduled: 'Tcia. Programada CVU',
    cvu_periodic: 'Tcia. Periódica CVU',
    cbu_immediate: 'Tcia. Inmediata CBU',
    cbu_scheduled: 'Tcia. Programada CBU',
    cbu_periodic: 'Tcia. Periódica CBU',
    bill_payment: 'Pago de Servicios',
    adjustment_reverse: 'Ajuste Reversa',
    gire_cashin: 'Gire Cashin',
    gire_cashout: 'Gire Cashout',
    gire_cashin_cost: 'Costo Gire Cashin',
    cargavirtual_antina: 'Recarga Antina',
    installment_payment: 'Pago de cuota credito',
    gire_cashout_cost: 'Gire Costo de Cashout',
    ctech_cashout_commission: 'Comisión C-TECH Cashout',
};
